import React from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { WhyChooseUs } from './components/WhyChooseUs';
import { HowItWorks } from './components/HowItWorks';
import { Gallery } from './components/Gallery';
import { Testimonials } from './components/Testimonials';
import { About } from './components/About';
import { ServiceArea } from './components/ServiceArea';
import { FAQ } from './components/FAQ';
import { BookingForm } from './components/BookingForm';
import { InstagramFeed } from './components/InstagramFeed';
import { FloatingActions } from './components/FloatingActions';
import { Footer } from './components/Footer';
interface AppProps {
  /** Language the site loads in. Visitors can still toggle EN/ES. */
  language?: 'en' | 'es';
  /** Show the Instagram feed section above the footer. */
  showInstagramFeed?: boolean;
}
export function App({
  language = 'en',
  showInstagramFeed = true
}: AppProps) {
  return <LanguageProvider initialLang={language} data-id="element-0" data-mp="3mjzsz5e2v41t">
      <div className="min-h-screen w-full bg-white" data-id="element-1" data-mp="3rc9hqi3ghy2i">
        <header className="sticky top-0 z-50 w-full" data-id="element-2" data-mp="3rcsyvwla8ifh">
          <AnnouncementBar data-id="element-3" data-mp="5opww5kum4f" />
          <Navbar data-id="element-4" data-mp="4wylxj0jajy" />
        </header>

        <main data-id="element-5" data-mp="82j0zgp5o9c">
          <Hero data-id="element-6" data-mp="2zl3bdjx5744s" />
          <Services data-id="element-7" data-mp="2zllen0i82im7" />
          <WhyChooseUs data-id="element-8" data-mp="2zm4xcjfp5b1a" />
          <HowItWorks data-id="element-9" data-mp="2zmwj72jhrued" />
          <Gallery data-id="element-10" data-mp="2zng1wlgyumtg" />
          <Testimonials data-id="element-11" data-mp="33mf6g4yschkd" />
          <About data-id="element-12" data-mp="33nq5jrhad155" />
          <ServiceArea data-id="element-13" data-mp="33n6xd2hftr4b" />
          <FAQ data-id="element-14" data-mp="33oi2b5mmd4x0" />
          <BookingForm data-id="element-15" data-mp="38m1g64fenfof" />
          {showInstagramFeed && <InstagramFeed data-id="element-16" data-mp="38l017ov9q91f" />}
        </main>

        <Footer data-id="element-17" data-mp="3dkuufz2inapn" />
        <FloatingActions data-id="element-18" data-mp="3dle1gkqmoeow" />
      </div>
    </LanguageProvider>;
}